export default __webpack_public_path__ + "static/media/bottomRight.72e0ca1a.svg";